// Importa los iconos necesarios desde react-bootstrap-icons
import { Tiktok, Instagram, Facebook, Whatsapp, Youtube, EnvelopeAtFill, Paperclip } from 'react-bootstrap-icons';

// Define y exporta la función getIcon
const getIcon = (url) => {
    if (url.includes('tiktok')) return <Tiktok size={20} />;
    if (url.includes('instagram')) return <Instagram size={20} />;
    if (url.includes('facebook')) return <Facebook size={20} />;
    if (url.includes('wa.me')) return <Whatsapp size={20} />;
    if (url.includes('youtube')) return <Youtube size={20} />;
    if (url.includes('mail.google')) return <EnvelopeAtFill size={20} />;
    return <Paperclip size={20} />;
};

export default getIcon;
